var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMastercardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ED0006",
  d: "M11.75 12.157a6.75 6.75 0 0 1-4.426 1.649C3.555 13.806.5 10.716.5 6.903S3.555 0 7.324 0c1.689 0 3.234.62 4.426 1.649A6.75 6.75 0 0 1 16.176 0C19.945 0 23 3.09 23 6.903s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9A000",
  d: "M11.75 12.157a6.92 6.92 0 0 0 2.398-5.254 6.92 6.92 0 0 0-2.398-5.254A6.75 6.75 0 0 1 16.176 0C19.945 0 23 3.09 23 6.903s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5E00",
  d: "M11.75 1.649a6.92 6.92 0 0 1 2.398 5.254 6.92 6.92 0 0 1-2.398 5.254 6.92 6.92 0 0 1-2.397-5.254 6.92 6.92 0 0 1 2.397-5.254"
}))));
export default SvgMastercardIcon;